import { StoreProps } from '@stores/Store'
import { I18nKey } from '@utils/i18n'
import { Component, ComponentClass, ReactNode } from 'react'

export interface SectionComponentClass<P = StoreProps | any> extends ComponentClass<P> {
  title: I18nKey
  icon: ReactNode
  trackerKey: string
  wrappedComponent?: SectionComponentClass<P>
}

// MUST mirror the section-list order in Section.util.ts. SimulatorPage resolves
// SECTIONS[sectionKey] by enum value for usage tracking, and GlobalStore.sectionUsage
// is indexed by it, so a drift here sends tracker events with the wrong key.
export enum SectionKey {
  BUSINESS, FRONTLINES, DEPTH, PATH_TO_BRONZE, BRONZE_INCENTIVES, BRONZE_CONSISTENCY_INCENTIVES,
  PERFORMANCE_PLUS, LEADERSHIP_PLUS_INCENTIVE, TWO_TIME_CASH_INCENTIVE
}

export abstract class SectionComponent<P = StoreProps | any, S = {}> extends Component<P, S> {
  static title: I18nKey
  static icon: ReactNode
  static trackerKey: string
}
